import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Input, DatePicker, Space, ConfigProvider } from "antd";
import { Image } from "@chakra-ui/image";
import { exportFormResponses, searchFormResponses } from "../../utils/api/formsApi.js";
import dayjs from 'dayjs';
import 'antd/dist/reset.css';
// import { formatDate, formatDateWithTime } from "../../utils/commons.js";

function FormManage() {
  const [details, setMessage] = useState({ message: "", type: "" });
  const [showToast, setShowToast] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState({
    agent: "",
    dateTo: new Date(),
    dateFrom: new Date(),
  });
  const [show, setShow] = useState(false);
  const [image, setImage] = useState("");
  const [fileName, setFileName] = useState("");
  const [exportable, setExportable] = useState({ items: [], headers: [] });
  const [width, setWidth] = useState(window.innerWidth);
  const [page, setPage] = useState("1");
  const [size, setSize] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const columns = [
    {
      title: <span className="text-white px-2 py-1 block">ID</span>,
      dataIndex: 'id',
      key: 'id',
      width: 80,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">TAS</span>,
      dataIndex: 'tas',
      key: 'tas',
      // width: 100,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">VISIT DATE</span>,
      dataIndex: 'visit_date',
      key: 'visit_date',
      // width: 120,
      align: "center",
      render: (date) => date ? dayjs(date).format('YYYY-MM-DD') : '',
    },
    {
      title: <span className="text-white px-2 py-1 block">VISIT TIME</span>,
      dataIndex: 'visit_time',
      key: 'visit_time',
      // width: 120,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">ACTIVITY NAME</span>,
      dataIndex: 'activity_name',
      key: 'activity_name',
      // width: 180,
      align: "center",
    },
    {
      title: <span className="text-white py-1 block">PROCAST CODE</span>,
      dataIndex: 'procast_code',
      key: 'procast_code',
      // width: 150,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">COMPANY NAME</span>,
      dataIndex: 'company_name',
      key: 'company_name',
      // width: 180,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">STORE NAME</span>,
      dataIndex: 'store_name',
      key: 'store_name',
      // width: 180,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">TRADE NAME</span>,
      dataIndex: 'trade_name',
      key: 'trade_name',
      // width: 150,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">REGION</span>,
      dataIndex: 'region',
      key: 'region',
      // width: 150,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">PROVINCE</span>,
      dataIndex: 'province',
      key: 'province',
      // width: 150,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">MUNICIPALITY</span>,
      dataIndex: 'municipality',
      key: 'municipality',
      // width: 150,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">MALL TYPE</span>,
      dataIndex: 'mall_type',
      key: 'mall_type',
      // width: 150,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">MALL NAME</span>,
      dataIndex: 'mall_name',
      key: 'mall_name',
      // width: 150,
      align: "center",
    },
    {
      title: <span className="text-white py-1 block">FLOOR NO.</span>,
      dataIndex: 'floor_no',
      key: 'floor_no',
      //   width: 100,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">ADDRESS</span>,
      dataIndex: 'address',
      key: 'address',
      width: 200,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">LANDMARK</span>,
      dataIndex: 'landmark',
      key: 'landmark',
      width: 150,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">COORDINATES</span>,
      dataIndex: 'coordinates',
      key: 'coordinates',
      width: 150,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">GOOGLE MAP</span>,
      dataIndex: 'google_map',
      key: 'google_map',
      width: 150,
      render: (url) => url ? <a href={url} target="_blank" rel="noopener noreferrer">View Map</a> : '',
    },
    {
      title: <span className="text-white px-2 py-1 block">LINK TYPE</span>,
      dataIndex: 'link_type',
      key: 'link_type',
      width: 120,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">INDUSTRY</span>,
      dataIndex: 'industry',
      key: 'industry',
      width: 150,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">STORE TYPE</span>,
      dataIndex: 'store_type',
      key: 'store_type',
      width: 150,
      align: "center",
    },
    {
      title: <span className="text-white px-2 py-1 block">ENGAGEMENT</span>,
      dataIndex: 'engagement',
      key: 'engagement',
      width: 150,
      align: "center",
    },
    {
      title: <span className="text-white py-1 block">ENGAGEMENT REMARKS</span>,
      dataIndex: 'engagement_remarks',
      key: 'engagement_remarks',
      width: 200,
      align: "center",
    },
    {
      title: <span className="text-white py-1 block">ADDED BY</span>,
      dataIndex: 'encoded_by',
      key: 'encoded_by',
      width: 200,
      align: "center",
    },
    {
      title: <span className="text-white py-1 block">ADDED ON</span>,
      dataIndex: 'added_on',
      key: 'added_on',
      width: 200,
      align: "center",
      render: (value) => value ? dayjs(value).format('MMM DD, YYYY hh:mm A') : '-',
    },
  ];

  window.addEventListener("resize", () => {
    setWidth(window.innerWidth);
  });

  const handleClose = () => setShow(false);
  const handleShow = (image, file) => {
    setFileName(file);
    setImage(image);
    setShow(true);
  };

  const handleExport = async () => {
    try {
      await exportFormResponses(searchData);
      setMessage({
        message: 'Export started successfully',
        type: 'success'
      });
      setShowToast(true);
      // Auto-hide the toast after 3 seconds
      setTimeout(() => {
        setShowToast(false);
      }, 3000);
    } catch (error) {
      console.error('Export failed:', error);
      setMessage({
        message: 'Export failed. Please try again.',
        type: 'error'
      });
      setShowToast(true);
      // Auto-hide the error toast after 5 seconds
      setTimeout(() => {
        setShowToast(false);
      }, 5000);
    }
  };

  const handleSearch = async (page = 1, pageSize = 10) => {
    setLoading(true);
    try {
      const response = await searchFormResponses({ 
        ...searchData, 
        pageSize 
      }, page);

      if (response?.data?.data) {
        const data = response.data.data;
        setSize(response.data.total_forms);
        setData(data);
        // Update pagination state
        setPagination({
          current: page,
          pageSize: pageSize,
          total: response.data.total_forms || 0,
        });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setMessage({
        message: 'Error fetching data. Please try again.',
        type: 'error'
      });
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    handleSearch(pagination.current, pagination.pageSize);
  };

  useEffect(() => {
    handleSearch(1, 10);
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#FB9C0C',
          borderRadius: 6,
        },
      }}
    >
    <div className="p-2">
      {showToast && (
        <div className={`alert alert-${details.type}`}>
          {details.message}
          <button type="button" className="btn-close" onClick={() => setShowToast(false)}></button>
        </div>
      )}
     <div className="text-center">
        <div className="col-12">
          <h1 className="title">FORM MANAGEMENT</h1>
        </div>
      </div>
      <div className="d-flex flex-wrap gap-3 mb-4 align-items-end">
        <div style={{ width: "250px" }}>
          <label style={{ fontWeight: 500, marginBottom: 4, display: 'block' }}>Date From</label>
          <DatePicker
            style={{ width: '100%' }}
            value={searchData.dateFrom ? dayjs(searchData.dateFrom) : null}
            onChange={(date) => setSearchData({ ...searchData, dateFrom: date ? date.toDate() : null })}
            format="YYYY-MM-DD"
            allowClear={false}
          />
        </div>
        <div style={{ width: "250px" }}>
          <label style={{ fontWeight: 500, marginBottom: 4, display: 'block' }}>Date To</label>
          <DatePicker
            style={{ width: '100%' }}
            value={searchData.dateTo ? dayjs(searchData.dateTo) : null}
            onChange={(date) => setSearchData({ ...searchData, dateTo: date ? date.toDate() : null })}
            format="YYYY-MM-DD"
            allowClear={false}
          />
        </div>
        <div style={{ width: "250px" }}>
          <label style={{ fontWeight: 500, marginBottom: 4, display: 'block' }}>Agent</label>
          <Input
            placeholder="Search Agent"
            value={searchData.agent}
            onChange={(e) => setSearchData({ ...searchData, agent: e.target.value })}
          />
        </div>
        <div className="d-flex align-items-end">
          <Space>
            <Button type="primary" onClick={() => handleSearch(1, 10)}>
              Search
            </Button>
            <Button type="primary" onClick={handleExport} disabled={!data || data.length === 0}>
              Export
            </Button>
          </Space>
        </div>
      </div>
      
      {/* <div className="row">
              <div className="col-12">
                <div style={{ overflowX: 'auto' }}>
                  <Table
                    columns={columns}
                    dataSource={data}
                    rowKey="key"
                    loading={loading}
                    pagination={{
                      ...pagination,
                      showSizeChanger: true,
                      pageSizeOptions: ['10', '20', '50', '100'],
                      showTotal: (total) => `Total ${total} items`,
                    }}
                    onChange={handleTableChange}
                    scroll={{ x: 'max-content' }}
                    bordered
                  />
                </div>
              </div>
            </div> */}
      <div className="row">
        <div className="col-12">
          <div style={{ overflowX: 'auto', maxHeight: '70vh', overflowY: 'auto' }}>
            <Table
              // className="no-hover"
              columns={columns}
              dataSource={data}
              rowKey="id"
              pagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: pagination.total,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                showTotal: (total) => `Total ${total} items`,
              }}
              onChange={handleTableChange}
              scroll={{ x: 'max-content' }}
              bordered
              size="small"
              loading={loading}
            />
          </div>
        </div>
      </div>
      <Modal 
        title={
          <span>
            Viewing -{" "}
            {fileName.length > 15
              ? fileName.substring(0, 15) + "..."
              : fileName}
          </span>
        }
        open={show}
        onCancel={handleClose}
        footer={null}
        centered
      >
        <div className="text-center">
          <Image
            src={image}
            fallbackSrc="../../logo.png"
            alt="Form Image"
            style={{ 
              maxWidth: "100%", 
              maxHeight: "70vh",
              objectFit: 'contain'
            }}
            className="img-fluid mx-auto"
          />
        </div>
      </Modal>
    </div>
    </ConfigProvider>
  );
}

export default FormManage;
